import { BasicFrame } from 'components/organisms';
import { Button, Card, Spacer, Title } from 'components';
import { CheckmarkIcon } from 'components/icons';
import { frameConfigBasicAffiliateFlow } from '../../../AppConfig';
import { getScreenTranslation } from '../../../utils/translations';
import { useBankAccountEnding } from '../../../hooks/useBankAccountEnding';
import { useNavigateOrigin } from 'hooks/useNavigateOrigin';
import { useTranslation } from 'react-i18next';
import classes from 'classnames';
import layout from 'scss/layout.module.scss';
import MoneyReceivalTimeFrame from 'components/molecules/LoanApprovedCallout/MoneyReceivalTimeFrame';
import styles from './RepeatedLoanSuccess.module.scss';

export default function RepeatedLoanSuccess() {
  const { loadingLogout, navigateOrigin } = useNavigateOrigin();
  const bankAccountEnding = useBankAccountEnding();
  const i18Next = useTranslation();

  const content = getScreenTranslation(
    'affiliatesRepeatedLoanSuccess',
    i18Next,
  );
  const bankAccount = `XXXX-XXXX-XXXX-XXXX-${bankAccountEnding}`;

  return (
    <BasicFrame
      {...frameConfigBasicAffiliateFlow}
      headerLayout="centered"
      contentLayoutClassName={layout['frame-x-padding']}
      contentWrapperClassName={layout['width-md']}
    >
      <Card
        className={classes(
          styles.container,
          layout['flex-column-centered'],
          layout['full-width-border-box'],
        )}
        dataTest="repeatedLoanSuccess-card"
      >
        <Title
          className={classes([styles.title])}
          dataTest="repeatedLoanSuccess-card-title"
          icon={<CheckmarkIcon />}
          text={content.title}
          forceColumn
        />
        <div
          className={classes(
            styles['card-wrapper'],
            layout['flex-column-centered'],
          )}
        >
          <div className={styles['arrow-positioner']}>
            <div className={styles.arrow} />
          </div>
          <Card
            intent="success"
            className={classes(
              styles.card,
              layout['flex-column-centered'],
              layout['full-width-border-box'],
            )}
            dataTest="repeatedLoanSuccess-card-2"
          >
            <div className={styles['card-content-wrapper']}>
              <div
                className={styles['title-card']}
                data-test="repeatedLoanSuccess-card-2-title"
              >
                {content.cardTitle}
              </div>
              <MoneyReceivalTimeFrame content={{ prefix1: 'De' }} />
              <Spacer marginTop="18px" marginBottom="5px">
                <div
                  className={styles['helper-text']}
                  data-test="repeatedLoanSuccess-card-2-helper-notification"
                  dangerouslySetInnerHTML={{
                    __html: content.helperNotification,
                  }}
                ></div>
              </Spacer>
            </div>
            <hr />
            <Spacer marginTop="15px">
              <div
                className={styles['helper-text']}
                data-test="repeatedLoanSuccess-card-2-helper-text"
                dangerouslySetInnerHTML={{
                  __html: content.helperBankAccount,
                }}
              ></div>
              <div
                className={styles['bank-account']}
                data-test="repeatedLoanSuccess-card-2-bank-account"
              >
                {bankAccount}
              </div>
            </Spacer>
          </Card>
        </div>
        <Spacer marginTop="40px" width="100%" className={layout['width-sm']}>
          <Button
            onClick={navigateOrigin}
            type="submit"
            fill
            dataTest="repeatedLoanSuccess-agree-btn"
            loading={loadingLogout}
          >
            {content.agreedBtn}
          </Button>
        </Spacer>
      </Card>
    </BasicFrame>
  );
}
